import React from 'react'
import { bezier, simpleLine } from '../../helpers/helpers'
import dataIp from '../../data/lines_ip'
import dataFibre from '../../data/lines_fibre'
import dataFibreCapa from '../../data/lines_fibre_capa'
import dataFibreExt from '../../data/lines_fibre-ext'

const Lines = ({ layer, p, name, mobile }) => {
  const data =
    name === 'fibre'
      ? layer === 'network'
        ? dataFibre
        : layer === 'capacity' && dataFibreCapa
      : name === 'ip'
      ? dataIp
      : name === 'fibreExt'
      ? dataFibreExt
      : undefined

  return (
    <g className={name}>
      {data.map((d, i) => (
        <path
          key={name + '-' + layer + '-' + i}
          d={mobile ? simpleLine(p)(d.geometry.coordinates) : bezier(p)(d.geometry.coordinates)}
          className={name}
          data={d}
        />
      ))}
    </g>
  )
}

export default Lines
